import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SETTINGS, Settings } from '../../../app.settings';
import { InsectaServiceBase } from '../insecta.base.service';
import { IPocCatalog, IPocCatalogAddInsect } from './poc.models';

@Injectable({
  providedIn: 'root'
})
export class PocService extends InsectaServiceBase {
  constructor(
    private http: HttpClient,
    @Inject(SETTINGS) settings: Settings
  ) {
    super(http, settings);
  }

  public pocGetCatalog(id: string): Observable<IPocCatalog> {
    return this.get<IPocCatalog>(`/poc/${id}/catalog`, 'v1');
  }

  public pocGetCatalogAddInsect(id: string): Observable<IPocCatalogAddInsect> {
    return this.get<IPocCatalogAddInsect>(`/poc/${id}/catalogAddInsect`, 'v1');
  }
}
